import { GeneralInfoContainer } from '../../../containers/product/product-create/general-info/GeneralInfoContainer'
import { ProductDataContainer } from '../../../containers/product/product-create/product-data/ProductDataContainer'
import { Button, Spinner } from 'avo-ui'
import { SEOSetting } from 'components/product/product-create/seo-setting/SEOSetting'
import { ProductPageSetting } from 'components/product/product-create/product-page-setting/ProductPageSetting'
import { ProductInfo } from 'components/product/product-create/product-info/ProductInfo'
import { SUBMIT_TYPE } from 'constants/constant'

export const ProductCreate = ({
    sectionProps,
    isLoading,
    isLoadingUpload,
    isCreating,
    isUpdating,
    isDrafting,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <GeneralInfoContainer {...sectionProps} />
                        <ProductDataContainer {...sectionProps} />
                        <ProductInfo {...sectionProps} />
                        <ProductPageSetting {...sectionProps} />
                        <SEOSetting {...sectionProps} />
                    </div>
                    <div className={'flex py-3 space-x-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            type={'outline'}
                            title={'Draft'}
                            loading={isLoadingUpload || isDrafting}
                            onClick={() => onSubmit(SUBMIT_TYPE?.DRAFT)}
                        />
                        <Button
                            className={'w-[200px]'}
                            title={'Publish'}
                            loading={isLoadingUpload || isCreating || isUpdating}
                            onClick={() => onSubmit(SUBMIT_TYPE?.PUBLISH)}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
